<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-3 sm:grid-cols-2">
        <div class="pb-2 sm:col-span-2">
            <h3
                :class="[
                    'text-base font-bold text-gray-700',
                    {
                        required: isRequiredLegalComplianceProfileAttribute(
                            'investment_targets',
                            'investment_objectives'
                        ),
                    },
                ]">
                {{ $t('investment_targets.legal_investment_objectives') }}
            </h3>
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.investment_objectives.security_coverage"
                name="investment_targets.investment_objectives.security_coverage"
                :label="$t('investment_targets.security_coverage_or_pension_plan')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.investment_objectives.retention_of_assets"
                name="investment_targets.investment_objectives.retention_of_assets"
                :label="$t('investment_targets.retention_of_assets')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.investment_objectives.distribution_of_assets"
                name="investment_targets.investment_objectives.distribution_of_assets"
                :label="$t('investment_targets.distribution_of_assets')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.investment_objectives.capital_gain"
                name="investment_targets.investment_objectives.capital_gain"
                :label="$t('investment_targets.capital_gain')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputTextActivatable
                v-model="formValues.investment_objectives.other_investment_target"
                name="investment_targets.investment_objectives.other_investment_target"
                label="Other:"></BaseInputTextActivatable>
        </div>
    </div>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-3 sm:grid-cols-2">
        <div class="sm:col-span-1">
            <BaseInputSelect
                v-model="formValues.investment_horizon"
                name="investment_targets.investment_horizon"
                :required="isRequiredLegalComplianceProfileAttribute('investment_targets', 'investment_horizon')"
                :label="$t('investment_targets.legal_investment_horizon')"
                :options="investmentHorizonOptions" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputSelect
                v-model="formValues.investment_frequency"
                name="investment_targets.investment_frequency"
                :required="isRequiredLegalComplianceProfileAttribute('investment_targets', 'investment_frequency')"
                :label="$t('investment_targets.legal_investment_frequency')"
                :options="investmentFrequencyOptions" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { InvestmentFrequencyOption, InvestmentHorizonOption } from '../../../../../typings'
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import BaseInputSelect from '../../../../base/BaseInputSelect.vue'
import { InvestmentTargets } from '../../../../../utilities/account/useAccountDataPersonal'
import { enumToSelectOptions } from '../../../../../utilities/helpers'
import {
    getLegalWidgetFormValidationRules,
    initializeLegalWidgetForm,
    isRequiredLegalComplianceProfileAttribute,
} from './forms'
import BaseInputTextActivatable from '../../../../base/BaseInputTextActivatable.vue'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
    modelValue: InvestmentTargets
}>()

const emit = defineEmits(['update:modelValue'])
const formValues = useVModel(props, 'modelValue', emit)

const investmentFrequencyOptions = enumToSelectOptions(InvestmentFrequencyOption, 'investment_frequency')

const investmentHorizonOptions = enumToSelectOptions(InvestmentHorizonOption, 'investment_horizon')

initializeLegalWidgetForm(getLegalWidgetFormValidationRules('investment_targets'))
</script>
